const combinePlugins = (plugins) => (state = {}, action) => (
  plugins.reduce((resolvedState, plugin) => plugin(resolvedState, action), state)
);

export default combinePlugins;
